// extracted by mini-css-extract-plugin
export default {"close":"osdMOxg nJoGg3s","header":"fE5iiPB","body":"yoMBxnZ","footer":"chUMIk9","content":"OF3J0al","content__displayed":"pnkNdpr"};